"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "m15.91 7.54-.82.57c-1.88-2.69-4.2-4-7.09-4-2.89 0-5.21 1.31-7.09 4l-.82-.57C2.17 4.56 4.76 3.11 8 3.11s5.83 1.45 7.91 4.43ZM11.55 8a3.55 3.55 0 1 1-7.102-.002A3.55 3.55 0 0 1 11.55 8Zm-1 0c0-1.41-1.15-2.55-2.55-2.55A2.56 2.56 0 0 0 5.45 8c0 1.4 1.15 2.55 2.55 2.55S10.55 9.4 10.55 8Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "m23.895 11.408-.922.645c-2.91-4.163-6.503-6.188-10.98-6.188-4.478 0-8.063 2.025-10.98 6.188l-.923-.646C3.225 6.924 7.117 4.74 11.985 4.74c4.867 0 8.76 2.183 11.895 6.668h.015ZM17.587 12A5.592 5.592 0 0 1 12 17.587 5.592 5.592 0 0 1 6.412 12 5.592 5.592 0 0 1 12 6.413 5.592 5.592 0 0 1 17.587 12Zm-1.125 0A4.468 4.468 0 0 0 12 7.538 4.468 4.468 0 0 0 7.537 12 4.468 4.468 0 0 0 12 16.462 4.468 4.468 0 0 0 16.462 12Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "m31.86 15.21-1.23.86c-3.88-5.55-8.67-8.25-14.64-8.25-5.97 0-10.75 2.7-14.64 8.25l-1.23-.86C4.3 9.23 9.49 6.32 15.98 6.32s11.68 2.91 15.86 8.89h.02Zm-8.41.79c0 4.11-3.34 7.45-7.45 7.45S8.55 20.11 8.55 16 11.89 8.55 16 8.55s7.45 3.34 7.45 7.45Zm-1.5 0c0-3.28-2.67-5.95-5.95-5.95-3.28 0-5.95 2.67-5.95 5.95 0 3.28 2.67 5.95 5.95 5.95 3.28 0 5.95-2.67 5.95-5.95Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "m47.64 22.92-1.538 1.072c-5.864-8.377-13.094-12.45-22.11-12.45-9.014 0-16.244 4.073-22.11 12.45L.346 22.92c6.24-8.918 13.973-13.252 23.64-13.252 9.668 0 17.407 4.335 23.64 13.252h.015ZM34.988 24c0 6.06-4.935 10.995-10.995 10.995S12.998 30.06 12.998 24s4.935-10.995 10.995-10.995S34.988 17.94 34.988 24Zm-1.875 0c0-5.025-4.088-9.12-9.12-9.12-5.033 0-9.12 4.088-9.12 9.12 0 5.032 4.087 9.12 9.12 9.12 5.032 0 9.12-4.087 9.12-9.12Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "m63.52 30.56-2.05 1.43c-7.82-11.17-17.46-16.6-29.48-16.6s-21.66 5.43-29.48 16.6L.46 30.56c8.32-11.89 18.63-17.67 31.52-17.67s23.21 5.78 31.52 17.67h.02ZM46.65 32c0 8.08-6.58 14.66-14.66 14.66S17.33 40.08 17.33 32s6.58-14.66 14.66-14.66S46.65 23.92 46.65 32Zm-2.5 0c0-6.7-5.45-12.16-12.16-12.16S19.83 25.29 19.83 32s5.45 12.16 12.16 12.16S44.15 38.71 44.15 32Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconShow = function IconShow(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Show' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Show"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconShow.sizes = [16, 24, 32, 48, 64];
IconShow.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconShow;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/Show.js
// module id = 2454
// module chunks = 0